// @flow

import { handleError } from '@tectonics/alert-handler';

import gpayIconSrc from './images/gpay-intent.svg';
import phonePeIconSrc from './images/phonePe-intent.svg';
import paytmIconSrc from './images/paytm-intent.svg';

export function getAppImageSrc(appName: string): string {

  switch(appName) {
    case 'gpay':
    case 'tez':
      return gpayIconSrc;
    case 'phonepe':
      return phonePeIconSrc;
    case 'paytm':
      return paytmIconSrc;
    default: {
      handleError(new Error(`getAppImageSrc - there is no image source for "${appName}"`));
      return '';
    }
  }
}
